import React, { useState } from "react";
import { Card, ListGroup } from "react-bootstrap";
import imgClipp from '../../assets/images/logo2clipp.png';
import ModalCard from "../ModalCard/ModalCard";
import CardService from '../../services/CardService';

const headerCard = {
    textAlign: 'right',
    backgroundColor: '#152c93',
}
const bodyCard = {
    textAlign: 'left',
    backgroundColor: '#152c93',
    color: 'white',
    height: '6em'
}
const styleImgClipp = {
    width: '70px',
    marginTop: '0px',
    paddingLeft: '2px'
}
const fondoFooter = {
    backgroundColor: '#152c93',
    textAlign: 'right',
    color: 'white'
}


const CardBannerClienteClipp = ({ data}) => {
    const [modalShow, setModalShow] = useState(false);
    const [dataCard, setDataCard] = useState({});

        const getDataTransactionCard = (dataTarjeta) => {

            CardService.findModal(dataTarjeta)
                .then((response) => {

                    if (Object.keys(response).length !== 0) {
                        setDataCard(response)
                        setModalShow(true)
                    }
                })
                .catch((error) => {
                    this.warningAlert('Ha ocurrido un error Traer informacion', error.m);
                    setModalShow(false)
                });
        }
        return (
            <>
                <Card style={{cursor: 'pointer'}} onClick={() => getDataTransactionCard(data.numeroTarjeta)}>
                    <ListGroup variant="flush">
                        <ListGroup.Item style={headerCard}>
                            <div>
                                <img src={imgClipp} alt="" style={styleImgClipp} />
                            </div>
                        </ListGroup.Item>
                        <ListGroup.Item style={bodyCard} >
                            <div>
                                <div><h6>{data.numeroTarjeta}</h6></div>
                            </div>
                            <div>
                                <div><h6>{data.estadoTarjeta}</h6></div>
                            </div>
                        </ListGroup.Item>
                        <ListGroup.Item style={fondoFooter}>
                            <div>
                                <h6>{data.tarifa}</h6>
                            </div>
                        </ListGroup.Item>
                    </ListGroup>
                </Card>
                {Object.keys(dataCard).length !== 0 ?

                    <ModalCard show={modalShow} onHide={() => setModalShow(false)} data={dataCard.data} nrotarjeta={data.numeroTarjeta}/>
                    : null
                }
            </>
        )
    }

export default CardBannerClienteClipp;